export enum ExerciseMark {
  None,
  Added,
  Deleting,
  Highlighted
}
